import { useParams } from "react-router-dom";
import DiscountDetailsWeb from "./layouts/DiscountDetails.web";
import DiscountDetailsMob from "./layouts/DiscountDetails.mob";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useState } from "react";
import { useGetDiscountDetailsQuery } from "src/store/apis/giftcards";
import { useTranslation } from "react-i18next";
import { DiscountDetailsHeader, DiscountDetailsSkeleton } from "./components";
import NoData from "@Components/NoData/NoData";


const DiscountDetailsComponent = withConditionalComponent(DiscountDetailsWeb,DiscountDetailsMob);


export default function DiscountsDetails() {
  const { code } = useParams();
  const {t, i18n} = useTranslation();
  const {data:items, isFetching, error} = useGetDiscountDetailsQuery({page:1, pagesize:2000000, lang:i18n.language, code});
  const imageUrl = items?.[0]?.imageUrl ?? undefined;
  const brandName = items?.[0]?.brand;
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const discount = items?.[selectedItemIndex];
  const itemCode = discount?.code;

  return (
    <div className="bg-background-default flex w-full flex-1 flex-col items-start gap-5 p-6 md:p-10">
      <DiscountDetailsHeader brandName={brandName} isFetching={isFetching} />
      {isFetching && (
        <div className="flex w-full flex-1 items-start justify-center md:p-5">
          <DiscountDetailsSkeleton />
        </div>
      )}
      {!isFetching && error && (
        <div className="flex w-full flex-1 items-center justify-center">
          <NoData description={t("Discounts.detailsUnavailable")} className="h-full w-full" />
        </div>
      )}
      {!isFetching && !error && (
        <div className="flex w-full flex-1 items-start justify-center md:p-5">
          <DiscountDetailsComponent
            trigger={isLargeScreen}
            props={{
              data: discount,
              imageUrl,
              itemCode: itemCode ?? undefined,
              items: items ?? [],
              selectedItemIndex,
              setSelectedItemIndex,
              brandName,
            }}
          />
        </div>
      )}
    </div>
  );
}
